import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { MwHttpService } from '@core/http';

import { News } from '../@models/news.model';

@Injectable()
export class MwNewsApiService {
  constructor(private readonly http: MwHttpService) {}

  getNews(newsCount: number): Observable<News[]> {
    return this.http.authGet(`/integration/v1/News/${newsCount}`, {
      ignoreNotifyStatusCodes: [403],
    });
  }

  increaseNewsViewsCounter(): Observable<any> {
    return this.http.authPost(`/integration/v1/News/Increment`);
  }
}
